'use client';

import React from 'react';
import Grid from '@mui/material/Grid2';
import { Typography } from '@mui/material';
import Radio from '@mui/material/Radio';
import PropTypes from 'prop-types';

function ServiceSelectBox({
  service,
  selected,
  onSelect
}) {
  return (
    <Grid
      sx={{
        px: 1.5,
        py: 1,
        border: selected ? '1px solid #00B4AA' : '1px solid #B4C2C9',
        borderRadius: '12px',
        backgroundColor: selected ? 'primary.50' : 'transparent',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        maxWidth: 'fit-content',
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={onSelect}
    >
      <Grid gap={1} container direction="row" sx={{ justifyContent: 'space-between', alignItems: 'start' }}>
        <Typography color='secondary.main' sx={{ fontWeight: 'bold' }}>
          {service.label}
        </Typography>

        <Radio
          checked={selected}
          sx={{ p: 0, color: 'primary.main' }}
        />
      </Grid>
    </Grid >
  );
}

ServiceSelectBox.propTypes = {
  chosenTimeSlot: PropTypes.bool,
  setChosenTimeSlot: PropTypes.func,
  timeSlot: PropTypes.string,
};

export default ServiceSelectBox;
